module.exports = __webpack_public_path__ + "img/poster.d95c7347.jpg";